import React from 'react';

import { Theme, ButtonV2 } from '@arc-ui/components';
import { BtIconChat } from '@arc-ui/icons';

import { CHAT_STYLE_MAP } from './constants';

export const LivePersonChat: React.FC<sharedComponents.LivePersonChat> = (props) => {
  const { chatType, analytics, altLabel } = props;
  const handleOnClick = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.sprChat('enable');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.sprChat('open');
  };

  const handleChatType = () => {
    switch (chatType) {
      case 'purpleButton':
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={handleOnClick}
            onKeyDown={handleOnClick}
            title="Not Arrived"
            className={CHAT_STYLE_MAP.get(chatType)}
          >
            <div>
              <div>{altLabel}</div>
            </div>
          </div>
        );
      case 'purpleButtonSecondary':
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={handleOnClick}
            onKeyDown={handleOnClick}
            title="Chat now"
            className={CHAT_STYLE_MAP.get(chatType)}
          >
            <div>
              <div>{altLabel}</div>
            </div>
          </div>
        );
      case 'purpleChatBtnWithIcon':
        return (
          <Theme theme='bt-business' >
            <ButtonV2
              type='button'
              buttonStyle='primary'
              ariaLabel="chat"
              onClick={handleOnClick}
              icon={BtIconChat}
              iconPosition="beforeText"
              label="Chat now"
              data-analytics-link={analytics}
            />
          </Theme >
        );
      case 'blackLink':
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={handleOnClick}
            onKeyDown={handleOnClick}
            title="Chat now"
            className={CHAT_STYLE_MAP.get(chatType)}
          >
            <div>
              <div>Chat now</div>
            </div>
          </div>
        );
      case 'purpleChatBtnSecondaryWithIcon':
        return (
          <Theme theme='bt-business'>
            <ButtonV2
              ariaLabel="chat"
              type='button'
              buttonStyle='primary'
              onClick={handleOnClick}
              icon={BtIconChat}
              iconPosition="beforeText"
              label="Chat now"
              id="btnOutlined"
              data-analytics-link={analytics}
            />
          </Theme >
        );

      case 'whiteLink':
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={handleOnClick}
            onKeyDown={handleOnClick}
            title="Chat now"
            className={CHAT_STYLE_MAP.get(chatType)}
          >
            <div>
              <div>Chat now</div>
            </div>
          </div>
        );
      default:
        return (
          <Theme theme='bt-business'>
            <ButtonV2
              ariaLabel="chat"
              onClick={handleOnClick}
              icon={BtIconChat}
              iconPosition="beforeText"
              label="Chat now"
              data-analytics-link={analytics}
            />
          </Theme >
        );
    }
  };

  return <>{handleChatType()}</>;
};
